import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../utils'

export const GENERATE_PDF_REQUEST = 'getcraft/generatePDF/GENERATE_PDF_REQUEST'
export const GENERATE_PDF_SUCCESS = 'getcraft/generatePDF/GENERATE_PDF_SUCCESS'
export const GENERATE_PDF_ERROR = 'getcraft/generatePDF/GENERATE_PDF_ERROR'

const initialStates = {
  generateData: {},
  isLoading: false,
}

export default createReducer(initialStates, {
  [GENERATE_PDF_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GENERATE_PDF_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [GENERATE_PDF_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
})

export function generatePDFv2(data, cb = () => { }) {
  const token = JSON.parse(isAuthorized())
  const toDispatch = {
    type: [
      GENERATE_PDF_REQUEST,
      GENERATE_PDF_SUCCESS,
      GENERATE_PDF_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/ps/generate_pdf',
      authorization: token,
      payloads: data,
      universeHost: true,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
  return toDispatch
}

